module.exports = __webpack_public_path__ + "img/MapThumb_EqualFooting.6585c330.webp";